module.exports = __webpack_public_path__ + "static/media/distribution-shift.19e99452.svg";